import React, { useState } from 'react';
import { Box, Container, Divider, Paper, Stack, Typography } from '@mui/material';
import { BarcodeScanButton } from '../components/barcode';
import { useLanguage } from '../contexts/LanguageContext';

const Scan: React.FC = () => {
  const { t } = useLanguage();
  const [scannedCode, setScannedCode] = useState('');

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="sm" sx={{ py: { xs: 5, sm: 8 } }}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="overline" color="primary.main">
              {t('barcode.scanTitle')}
            </Typography>
            <Typography component="h1" variant="h4" sx={{ mt: 0.5 }}>
              {t('barcode.testTitle')}
            </Typography>
            <Typography color="text.secondary" sx={{ mt: 1 }}>
              {t('barcode.testDescription')}
            </Typography>
          </Box>

          <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
            <Stack spacing={2}>
              <BarcodeScanButton
                label={t('barcode.scan')}
                onDetected={setScannedCode}
                size="large"
              />
              <Divider />
              <Box>
                <Typography variant="overline" color="text.secondary">
                  {t('barcode.scanResult')}
                </Typography>
                <Typography
                  component="output"
                  aria-live="polite"
                  variant={scannedCode ? 'h5' : 'body2'}
                  sx={{ display: 'block', overflowWrap: 'anywhere', mt: 0.5 }}
                >
                  {scannedCode || t('barcode.scanEmpty')}
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Stack>
      </Container>
    </Box>
  );
};

export default Scan;
